import {Button} from '@/components/ui/button/Button'
import {useAsync} from '@/hooks/useAsync'
import {useTranslation} from '@/translations/i18n'
import {errorHandler} from '@/utilities/helpers'
import {httpSendVerificationEmail} from '@/features/account/services/account.http'
import {toast} from '@/utilities/toast/toast'

export const SendVerificationEmailButton = ({isLoading, userId}: {isLoading: boolean; userId: string}) => {
    const {t} = useTranslation()
    const sendVerificationEmailAsync = useAsync()

    const handleSendVerificationEmail = async () => {
        try {
            await sendVerificationEmailAsync.run(httpSendVerificationEmail({urlParams: {userId}}))
            toast.success(t('account:verification_email_sent'))
        } catch (error) {
            errorHandler(error)
        }
    }

    return (
        <Button
            variant="tertiary"
            shape="text"
            disabled={isLoading || sendVerificationEmailAsync.isLoading}
            onClick={handleSendVerificationEmail}
        >
            {t('account:send_new_email')}
        </Button>
    )
}
